import { cn } from "@/lib/utils";
import { useTaskDashboard } from "@/contexts/TaskDashboardContext";

/** Mini barra e badges extras no item Tarefas (sidebar expandida). */
export function TaskNavMenuExtras() {
  const { dayProgress, counts, hasUrgentAttention } = useTaskDashboard();

  if (dayProgress.total === 0 && counts.overdue === 0) return null;

  return (
    <div className="w-full pl-7 pr-1 pb-1 space-y-1">
      <div className="h-1 w-full rounded-full bg-muted overflow-hidden">
        <div
          className={cn(
            "h-full rounded-full transition-all duration-500",
            dayProgress.percent >= 100
              ? "bg-emerald-500"
              : hasUrgentAttention
                ? "bg-destructive"
                : "bg-amber-500",
          )}
          style={{
            width: `${dayProgress.total > 0 ? dayProgress.percent : 0}%`,
          }}
        />
      </div>
      <p className="text-[9px] text-muted-foreground tabular-nums">
        {dayProgress.done}/{dayProgress.total} hoje
      </p>
    </div>
  );
}

export function TaskNavBadges() {
  const { counts, hasUrgentAttention, pendingTotal } = useTaskDashboard();

  if (counts.overdue > 0) {
    return (
      <span className="ml-auto shrink-0 flex items-center gap-1">
        <span className="rounded-full bg-destructive px-1.5 py-0.5 text-[10px] font-semibold leading-none text-destructive-foreground tabular-nums animate-pulse">
          {counts.overdue}
        </span>
        <span className="text-[9px] font-medium text-destructive hidden sm:inline">
          Atraso
        </span>
      </span>
    );
  }

  if (pendingTotal > 0) {
    return (
      <span className="ml-auto shrink-0 rounded-full bg-amber-500 px-1.5 py-0.5 text-[10px] font-semibold leading-none text-white tabular-nums">
        {pendingTotal}
      </span>
    );
  }

  return null;
}

export function taskNavIconPulseClass(hasUrgent: boolean): string {
  return hasUrgent
    ? "ring-2 ring-destructive/60 rounded-md animate-pulse"
    : "";
}
